import { BedAndBreakfastIcon, CampIcon, CharterIcon } from '../components/Icons';

export const getSupplierIcon = (iconType: string) => {
  const supplierPackageType = iconType?.trim()?.toLowerCase();

  switch (supplierPackageType) {
    case 'surf charter':
      return CharterIcon;
    case 'bed & breakfast':
      return BedAndBreakfastIcon;
    case 'surf camp':
      return CampIcon;
    default:
      return () => null;
  }
};

const defaultExport = {
  getSupplierIcon,
};

export default defaultExport;
